import { render, staticRenderFns } from "./TranslateIcon.vue?vue&type=template&id=6674e23c&"
import script from "./TranslateIcon.vue?vue&type=script&lang=js&"
export * from "./TranslateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports